<template>
	<div class="app--alert alert" :class="classes" role="alert" v-show="active">
		<div class="d-flex align-items-center">
			<div v-if="icon" class="icon flex-shrink-1 me-2">
				<app--icon :value="icon" type="far" class="fa-fw"></app--icon>
			</div>
			<div class="message">
				<div class="title" v-if="title" :class="{'pe-3': close}">{{title}}</div>
				<div class="description" v-if="description" v-html="description" />
			</div>
		</div>
		<button v-if="close" type="button" class="btn-close btn-sm" aria-label="Close" @click="dismiss"></button>
	</div>
</template>

<script>
	export default {
		emits: ['dismiss'],
		props: {
			description: { type: String,  default: ''     },
			icon:        { type: String,  default: ''     },
			title:       { type: String,  default: ''     },
			type:        { type: String,  default: 'light'},
			close:       { type: Boolean, default: false  },
		},
		computed: {
			classes() { return 'alert-' + this.type + (this.close ? ' alert-dismissible' : '') }
		},
		data() { return {active: true } },
		methods: {
			dismiss() { this.active = false; this.$emit('dismiss') }
		}
	}
</script>
